import React from 'react';

import { useIntl } from 'react-intl';

import Image from '@atlaskit/image';

import { GlobalSideNavigationNoContent } from '../../../../common/ui/no-content';

// eslint-disable-next-line import/extensions -- Jest resolves SVG assets in this package only when the extension is present.
import StarredEmpty from './assets/starred-empty.svg';
import messages from './messages';

export type ObjectListStarredEmptyStateProps = {
	errorDescription?: string;
};
export function ObjectListStarredEmptyState({
	errorDescription,
}: ObjectListStarredEmptyStateProps): React.JSX.Element {
	const { formatMessage } = useIntl();

	return (
		<GlobalSideNavigationNoContent
			testId="object-list-flyout--starred-empty-state"
			renderImage={() => <Image src={StarredEmpty} width={96} alt="" />}
			heading={formatMessage(messages.starredEmptyStateHeader)}
			description={errorDescription ?? formatMessage(messages.starredEmptyStateDescription)}
		/>
	);
}
